export const tailwindClasses = {
    tag: 'px-[4px] absolute left-[-6px] bottom-[-10px] text-[12px] text-[#fff] rotate-[-9deg] rounded-[4px]',
    coming_soon: 'main-content pt-[85px] pl-[56px]',
    main_wrap: `main-content pb-[38px] lg:pb-[48px]`,
    h1_style: "text-[#58a4ae]",
    city_brief_wrap: 'w-full mt-[26px] flex-[0_0_100%] md:w-[100%] md:flex-[0_0_100%]'
}